import { formatKr } from "../lib/format";

const URL_RE = /\s*(?:Se opslaget:\s*)?(https?:\/\/\S+)/;

// Activity text; links (stored separately or, for older events, inside the text) render as a short "Se opslaget ↗"
export function EventText({ ev }) {
  const m = ev.link ? null : (ev.text || "").match(URL_RE);
  const link = ev.link || m?.[1];
  const text = m ? ev.text.replace(URL_RE, "").trim() : ev.text;
  return (
    <>
      {text}
      {link && (
        <>
          {" "}
          <a className="feed-link" href={link} target="_blank" rel="noopener noreferrer" data-testid={`event-link-${ev.id}`}>
            Se opslaget ↗
          </a>
        </>
      )}
    </>
  );
}

const STATUS_LABEL = {
  pending_confirm: "Afventer bekræftelse",
  reserved: "Reserveret",
  waitlist: "Venteliste",
  picked_up: "Afhentet",
  cancelled: "Annulleret",
  no_show: "Udeblevet",
  expired: "Udløbet",
};

export const Pill = ({ status, label }) => (
  <span className={`pill ${status}`}>{label ?? STATUS_LABEL[status] ?? status}</span>
);

export function PriceTag({ offer, big = false }) {
  const normal =
    offer.normal_price_ore && offer.normal_price_ore > offer.price_ore ? <s> {formatKr(offer.normal_price_ore)}</s> : null;
  return (
    <span className={`tag${big ? " big" : ""}`}>
      {formatKr(offer.price_ore)}
      {normal}
    </span>
  );
}

export function StockBar({ stats }) {
  const t = Math.max(1, stats.stock_total);
  const w = (n) => `${((100 * n) / t).toFixed(1)}%`;
  return (
    <>
      <div className="stock" role="img" aria-label={`${stats.held} af ${stats.stock_total} stk. reserveret`}>
        <i className="picked" style={{ width: w(stats.picked_up) }} />
        <i className="reserved" style={{ width: w(stats.reserved) }} />
        <i className="pending" style={{ width: w(stats.pending) }} />
      </div>
      <div className="stock-legend">
        <span>
          <b>{stats.available}</b> ledige af {stats.stock_total}
        </span>
        <span>
          <b>{stats.reserved + stats.pending}</b> reserveret
        </span>
        {stats.picked_up ? (
          <span>
            <b>{stats.picked_up}</b> hentet
          </span>
        ) : null}
        {stats.waitlist_count ? (
          <span>
            <b>{stats.waitlist_count}</b> på venteliste
          </span>
        ) : null}
      </div>
    </>
  );
}

export const Thumb = ({ offer }) =>
  offer.image_path ? (
    <span className="thumb-wrap">
      <img className="thumb" src={offer.image_path} alt="" />
      {offer.has_video && <span className="thumb-play" aria-label="Video">▶</span>}
    </span>
  ) : (
    <span className="thumb" aria-hidden="true">
      🛒
    </span>
  );

export { STATUS_LABEL };
